<template>
  <div id="onfocusheight">
    <div class="page-title">
      <h4>Cerere oferta</h4>
    </div>

    <table class="table app_table">
      <thead>
        <tr class="app_table_header">
          <th scope="col">Expeditor</th>
          <th scope="col">Subiect</th>
          <th scope="col">Data & Ora</th>
          <th scope="col">Conținut</th>
        </tr>
      </thead>
      <tbody v-if="emails.length">
        <tr v-for="(email, index) in emails" :key="index">
          <td>{{ email.from }}</td>
          <td>{{ email.subject }}</td>
          <td>{{ formatDate(email.date) }}</td>
          <td>
            <span v-if="!email.expanded">
              {{ truncateBody(email.body) }}
              <a href="#" @click.prevent="email.expanded = true"> Vezi tot </a>
            </span>
            <span v-else>
              {{ email.body }}
              <a href="#" @click.prevent="email.expanded = false"> Ascunde </a>
            </span>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="4">Nu s-au găsit emailuri.</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Emails',
  data() {
    return {
      emails: []
    }
  },
  methods: {
    async fetchEmails() {
      try {
        const response = await axios.get('/imap-emails')
        this.emails = response.data.map(email => ({
          ...email,
          expanded: false
        }))
         this.$store.dispatch('hideLoading')
      } catch (error) {
        console.error('Eroare la încărcarea emailurilor:', error)
      }
    },
    truncateBody(body) {
      if (!body) return ''
      return body.length > 100 ? body.substring(0, 100) + '...' : body
    },
    formatDate(dateString) {
      const date = new Date(dateString)
      return new Intl.DateTimeFormat('ro-RO', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }).format(date)
    }
  },
  created() {
    this.fetchEmails()
  }
}
</script>